// Leaflet, exposed as the `L` global.
//
// beautifymarker and leaflet.markercluster don't import Leaflet — they attach
// themselves (`L.BeautifyIcon = …`, `L.MarkerClusterGroup = …`) to a `window.L`
// they expect to already exist. Two things have to be true for that to work:
//
// 1. `window.L` must be set BEFORE the plugins evaluate. ES import declarations
//    are hoisted and evaluated depth-first in declaration order, before any
//    statement in the importing module's body — so this assignment lives in
//    its own module, which map.js imports first. See #233.
//
// 2. `window.L` must be Leaflet's real export object, which is mutable. A
//    namespace import (`import * as L`) hands back a frozen ES module namespace,
//    and the plugins then throw "Cannot add property …, object is not
//    extensible" — which aborts evaluation of the entire bundle. The default
//    import is the CommonJS `module.exports` itself.
//
// Our own code should import `L` from here rather than reach for the global.
import L from "leaflet";

window.L = L;

export default L;
